import React from "react";
import { useDroppable } from "@dnd-kit/core";
// import backgroundImage from "../../../assets/images/background-reservation.png";

const Droppable = React.forwardRef((props, ref) => {
  const { isOver, setNodeRef } = useDroppable({
    id: props.id,
    onDrop: () => {
      props.onDrop();
    },
  });

  const style = {
    width: "100%",
    maxWidth: "1300px",
    aspectRatio: "2 / 1",
    position: "relative",
    overflow: "hidden",
    backgroundImage: `url(data:image/jpeg;base64,${props.backgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  return (
    <div
      ref={(node) => {
        setNodeRef(node);
        if (ref) ref.current = node;
      }}
      style={style}
    >
      {props.children}
      {isOver && (
        <div className="reservations-schema-droppable-overlay">
          {props.children}
        </div>
      )}
    </div>
  );
});

export { Droppable };
